import { type ReactNode } from 'react';

export const RECENT_SEARCHES = {
    TYPE: 'RECENT',
    LOCAL_STORAGE: 'recentNftSearches',
    MAX_TERMS: 6,
};

export const SEARCH_PAGE_PATH = '/nft-collections/search/';

export const SEARCH_QUERY_PARAM = 'q';

export const KEY_UP_VALUE = 'up';
export const KEY_DOWN_VALUE = 'down';

export type TermType = {
    term?: string;
    subterm?: string | ReactNode;
    urlLabel?: string;
    image?: ReactNode;
    defaultAvatar?: string;
};

export type SuggestionType = {
    type?: string;
    terms?: TermType[];
};

export type CursorType = {
    term: string;
    highlightId: string;
    link?: string;
};
